import { connect } from 'react-redux'
import { authActions } from 'store/user'
import { selectLanguage } from 'store/locales'
import ProfilePage from '../components/ProfilePage'
import { downloadConsentPDF, downloadSignConsentPDF, onFetchConsentDetails } from '../../../../Consent/modules/Consent'
import { uploadFile } from '../modules/FileUpload'
import { isBlockConsent } from '../../../../Consent/utils/consentUtils'

const mapStateToProps = state => {
  const { user, files, locales, strings, consent, caregiver } = state
  const study = user?.study ?? {}
  const { consent_required: consentRequired } = study
  const { localesList, selectedLocale } = locales
  const showConsentModal = isBlockConsent(user, consent)

  return {
    consentRequired,
    email: user.email,
    username: user.username,
    files,
    firstName: user.fname,
    localesList,
    selectedLocale,
    siteName: user?.site?.label ?? '',
    strings,
    studyID: user.study_id,
    completedConsents: consent?.completedConsents || [],
    pendingConsents: consent?.v2Consents || [],
    showConsentModal,
    user,
    caregiver
  }
}

const mapDispatchToProps = {
  onLogout: authActions.logout,
  downloadConsentPDF,
  downloadSignConsentPDF,
  selectLanguage,
  uploadFile,
  onFetchConsentDetails,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfilePage)
